<h1 mat-dialog-title>{{ 'errorDialog.title' | translate }}</h1>

<mat-dialog-content>
  {{ message | translate }}
</mat-dialog-content>

<mat-dialog-actions>
  <button color="primary" mat-raised-button (click)="closeDialog()">ΟΚ</button>
</mat-dialog-actions>
